import React, { useState } from "react";
import { Button, Form, Input, Statistic, notification, Alert } from "antd";
import { useAuth } from "context/providers/auth";
import { handleErrors } from "helpers/api";
import dayjs from "dayjs";
import AuthLayout from "components/AuthLayout";
import { Link } from "react-router-dom";

const SignIn = () => {
  const [account_blocked_to, setAccountBlockedTo] = useState(
    localStorage.getItem("account_blocked_to" || null)
  );
  const [is_loading, setLoading] = useState(false);
  const { handleLogin } = useAuth();

  const onCountdownFinish = () => {
    setAccountBlockedTo(null);
    localStorage.removeItem("account_blocked_to");
  };

  const onFinish = async (values) => {
    try {
      if (!!account_blocked_to) {
        return;
      }
      setLoading(true);
      await handleLogin(values);
    } catch (error) {
      if (error?.response?.data?.error_type === "account_temporary_blocked") {
        const { date } = error.response.data;

        localStorage.setItem("account_blocked_to", date);
        setAccountBlockedTo(date);
      }
      notification.error({ message: handleErrors(error) });
    } finally {
      setLoading(false);
    }
  };

  const is_account_blocked = !!account_blocked_to;

  return (
    <AuthLayout title="Logowanie">
      <div className="auth-page__form">
        <Form
          name="basic"
          initialValues={{
            email: "",
            password: "",
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="E-mail"
            name="email"
            hasFeedback
            rules={[
              {
                type: "email",
                message: "Niepoprawny e-mail",
              },
              {
                required: true,
                message: "Email jest wymagany!",
              },
              {
                max: 128,
                message: "Przekroczono maksymalną ilość znaków!",
              },
            ]}
          >
            <Input placeholder="E-mail" maxLength={128} />
          </Form.Item>
          <Form.Item
            label="Hasło"
            name="password"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Hasło jest wymagane!",
              },
              {
                max: 128,
                message: "Przekroczono maksymalną ilość znaków!",
              },
            ]}
          >
            <Input.Password maxLength={128} placeholder="Hasło" />
          </Form.Item>
          {is_account_blocked && <p>Możliwość ponownego zalogowania:</p>}
          <Button
            loading={is_loading}
            disabled={is_loading || is_account_blocked}
            type="primary"
            htmlType="submit"
            block
            size="large"
          >
            {is_account_blocked ? (
              <Statistic.Timer
                value={dayjs(account_blocked_to)}
                type="countdown"
                onFinish={onCountdownFinish}
              />
            ) : (
              "Zaloguj się"
            )}
          </Button>
        </Form>
      </div>
      {is_account_blocked ? (
        <Alert
          className="m-t-20"
          message="Wygląda na to, że nie pamiętasz hasła. Po upływie czasu skorzystaj z funkcji przypomnienia hasła, bo po 5 nieudanych próbach Twoje konto zostanie zablokowane."
          type="error"
        />
      ) : (
        <div className="auth-page__links">
          <Link to="/sign-up">Nie masz konta? Zarejestruj się!</Link>
          <Link to="/reset-password">Zapomniałeś hasła?</Link>
        </div>
      )}
    </AuthLayout>
  );
};

export default SignIn;
